Bingo.Alert = {};

Bingo.Alert.destroyAlert = function (alert, seconds) {
    setTimeout(() => {
        alert.fadeOut('slow', () => {
            alert.remove();
        });
    }, seconds * 1000);
};

Bingo.Alert.destroyTemporary = function () {
    const alerts = $('.js-alertTemporary');
    alerts.each(function () {
        Bingo.Alert.destroyAlert($(this), 15);
    });
};

Bingo.Alert.init = function () {
    this.destroyTemporary();
};
